/**
 * Image optimization helper.
 *
 * Routes large source images through the wsrv.nl CDN proxy which:
 *   - resizes to the requested width
 *   - converts to WebP (≈40–70% smaller than PNG/JPG)
 *   - serves compressed bytes from its own CDN (no referrer issues)
 *
 * Result: most images drop from 1–3 MB to 50–200 KB on mobile.
 */
export const optimized = (src, { w = 1000, h, q = 80 } = {}) => {
    if (!src) return src;
    if (src.startsWith("https://wsrv.nl/")) return src;
    // Skip proxy for our own backend image endpoint (already binary-served with cache headers)
    if (src.includes("/api/images/")) return src;
    const params = new URLSearchParams({
        url: src,
        w: String(w),
        q: String(q),
        output: "webp",
    });
    if (h) params.set("h", String(h));
    if (h) params.set("fit", "cover");
    return `https://wsrv.nl/?${params.toString()}`;
};
